<template>
<div style="height: 100%;width: 100%;overflow: auto">
  <el-form ref="formData" :model="busData" label-width="150px" :rules="rules" style="margin: 20px" >
    <el-row>
      <el-col :span="22">
        <el-form-item label="部门：">
          <el-input v-model="parentData.label" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="busData.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="性别：" prop="sex">
          <el-select v-model="busData.sex">
            <el-option label="男" key="male" value="male"></el-option>
            <el-option label="女" key="female" value="female"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="职位：" prop="position">
          <el-cascader :props="props" :options="positionList" style="width: 200px"
                       :show-all-levels="false" placeholder="请选择" v-model="busData.position"
                       clearable filterable/>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="业务关键人：" prop="business_key">
          <el-select v-model="busData.business_key">
            <el-option label="是" key="true" value="true"></el-option>
            <el-option label="否" key="false" value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="在职状态：" prop="status">
          <el-select v-model="busData.status">
            <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="入职年份：" prop="employment_year">
          <el-input v-model="busData.employment_year"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="离职年份：">
          <el-input v-model="busData.resignation_year"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="企业邮箱：">
          <el-input v-model="busData.mailbox"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="联系方式：" >
          <div>
            <div v-for="item in busData.phoneList"  style="display:flex;margin-bottom: 10px;align-items: center">
              <el-input v-model="item.phone" placeholder="号码" style="width: 200px"></el-input>
              <el-select style="margin-left: 10px;width: 150px" placeholder="号码类型" v-model="item.type">
                <el-option :key="'phone'" :value="'phone'" :label="'电话'">电话</el-option>
                <el-option :key="'work'" :value="'work'" :label="'办公'">办公</el-option>
                <el-option :key="'other'" :value="'other'" :label="'其它'">其它</el-option>
              </el-select>
              <div style="margin-left: 10px; line-height: 20px;cursor: pointer;" @click="addLine">
              <el-icon><Plus /></el-icon>
              </div>
              <div style="margin-left: 20px; line-height: 20px;cursor: pointer; " @click="delLine(item)">
              <el-icon><Minus /></el-icon>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="备注：">
          <el-input type="textarea" rows="3" v-model="busData.remark"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="照片/微信头像：">
          <KfImageUpload v-model="busData.wechat_img" :limit="1" @fileChange="setWechatImageId"></KfImageUpload>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="联系人资料截图：">
          <KfImageUpload v-model="busData.contact_info_img" :limit="1" @fileChange="setContactImageId"></KfImageUpload>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="名片正反面：">
          <KfImageUpload v-model="busData.calling_card" :limit="2" @fileChange="setCallingImageId"></KfImageUpload>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="" >
          <el-button @click="add">添加</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</div>
</template>

<script>
import {Minus, Plus} from "@element-plus/icons-vue";
import {nanoid} from "nanoid";

export default {
  name: "CompanyContactAdd",
  components: {Minus, Plus},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    getDeptTreeData: {
      type: function () {
      },
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      busData:{
        phoneList:[]
      },
      positionList:[],
      props: {
        emitPath:false,
        expandTrigger:'hover',
        value: 'id',
        label: 'position'
      },
      rules: {
        name: [{required: true, message: '', trigger: 'blur'}],
        sex: [{required: true, message: '', trigger: 'blur'}],
        position: [{required: true, message: '', trigger: 'blur'}],
        business_key: [{required: true, message: '', trigger: 'blur'}],
        status: [{required: true, message: '', trigger: 'blur'}],
        //employment_year: [{required: true, message: '', trigger: 'blur'}],
      }

    }
  },
  computed: {
    statusList() {
      return this.$store.getters['core/getDictList']('user_status');
    },
  },
  created() {
    this.addTwoLine();
    this.getPositionList();
  },
  methods: {
    add(){
      this.$refs.formData.validate(async valid => {
        if (!valid) {
          return this.$message.error("有必选或必填项为空");
        }
        let params = this.busData;
        //联系方式简化
        let phoneList = [];
        for (let item of this.busData.phoneList) {
          const index = this.busData.phoneList.indexOf(item) + 1;
          if (item.phone) {
            if (!item.type) {
              this.$message.error("第" + index + "行，请选择号码类型");
              return;

            }
          }
          if (item.type) {
            if (!item.phone) {
              this.$message.error("第" + index + "行，请输入号码");
              return;
            }
          }
          if (item.phone && item.type) {
            phoneList.push(item);
          }
        }
        this.busData.phoneList = phoneList;
        params.department_id = this.parentData.id;
        params.company_id = this.parentData.company_id;
        this.$http('companyOrganization.addCompanyContact', params).then(() => {
          this.$message.success("提交成功");
          this.$fn.reloadTreeData();
          this.$fn.closeWindow();
        })
      });
    },
    async getPositionList(){
      this.positionList = await this.$http('crmDsService.getContactPosition');
    },
    addTwoLine(){
      this.busData.phoneList.push({
        id: nanoid(),
      })
      this.busData.phoneList.push({
        id: nanoid(),
      })
    },
    addLine(){
      this.busData.phoneList.push({
        id: nanoid(),
      })
    },
    delLine(itemNode){
      if(this.busData.phoneList.length === 1){
        return;
      }
      let delId = itemNode.id
      this.busData.phoneList.forEach(item => {
        if(delId === item.id){
          this.busData.phoneList.splice(this.busData.phoneList.indexOf(item),1)
        }
      })

    },
    setWechatImageId(ids){
      if(ids.length>0){
        this.busData.wechat_img=ids
      }else{
        this.busData.wechat_img=[]
      }
    },
    setContactImageId(ids){
      if(ids.length>0){
        this.busData.contact_info_img=ids
      }else{
        this.busData.contact_info_img=[]
      }
    },
    setCallingImageId(ids){
      if(ids.length>0){
        this.busData.calling_card=ids
      }else{
        this.busData.calling_card=[]
      }
    },
  }
}
</script>

<style scoped>

</style>